/**
 * usage:
 in main.js:
 import BanetAcl from 'vue-acl'
 Vue.use( BanetAcl, { router: router, d_permission: 'any', store: store } );
 required router and store
 * @type {BanetAcl}
 */

"use strict";

class BanetAcl {

   init(router, defaultPermission, store, aclRedirect, roles) {
      this.router = router;
      this._store = store;
      this.defaultPermission = defaultPermission;
      this.aclRedirect = aclRedirect;
      this.aclRoles = roles;
      // let logged = this._store.getters.getRole;
      // if(!logged){
      //    this._store.dispatch('setAcl', defaultPermission);
      // } else {
      //    this._store.dispatch('setAcl', this.aclRoles.indexOf(logged) == -1 ? this.defaultPermission : logged);
      // }
      // todo: delete after test
      // if(sessionStorage.getItem('acl_current') == null) {
      //    sessionStorage.setItem('acl_current', defaultPermission);
      //    this._store.state.acl_current = defaultPermission
      // } else {
      //    let role = sessionStorage.getItem('acl_current');
      //    this._store.state.acl_current = this.aclRoles.indexOf(role) == -1 ? this.defaultPermission : role;
      //    // this._store.state.acl_current = sessionStorage.getItem('acl_current')
      // }
   }

   check(permission) {
      let logged = this._store.getters.getRole;
      if(Array.isArray(permission)) {
         return permission.indexOf(logged) !== -1 ? true : false;
      }
      else {
         return logged == permission;
      }
   }

   set active(active) {
      if(active) active = this.aclRoles.indexOf(active) == -1 ? this.defaultPermission : active;
      this._store.dispatch('setAcl', active);
      // todo: delete after test
      // sessionStorage.setItem('acl_current', active || null);
      // this._store.state.acl_current = sessionStorage.getItem('acl_current')
   }

   get active() {
      return this._store.getters.getRole;
      // return this._store.state.acl_current
   }

   set router(router) {

      router.beforeEach((to, from, next) => {
         // V3 =>
         if(to.meta.permission == 'reset'){
            next();
         }
         // <+ V3
         else if(typeof to.meta.permission == 'undefined') {
            return false;
         } else {
            let permission = (to.meta.permission.indexOf('.') !== -1) ? to.meta.permission.split('.') : to.meta.permission;
            if(!this.check(permission)) {
               let logged = this._store.getters.getRole;
               if(!logged || logged == 'undefined') logged = 'none';
               if(this.aclRedirect[logged] != to.path) {
                  router.push(this.aclRedirect[logged]);
                  return false;
               } else {
                  next();
               }
            }
            next();
         }
      })
   }
}

let acl = new BanetAcl();

BanetAcl.install = function (Vue, _ref) {
   var router = _ref.router,
      d_permission = _ref.d_permission,
      store = _ref.store,
      aclRedirect =_ref.aclRedirect,
      roles =_ref.roles; // all available roles array

   acl.init(router, d_permission, store, aclRedirect, roles);




   Vue.prototype.can = function (permission) {
      if (typeof permission != 'undefined') {
         permission = permission.indexOf('.') !== -1 ? permission.split('.') : permission;
      }
      return acl.check(permission);
   };

   Vue.prototype.changeAccess = function (newAccess) {
      acl.active = newAccess;
   };
};

export default BanetAcl;


// WEBPACK FOOTER //
// ./src/Banet/plugins/BanetAcl.js